export type InactivityDialogConfig = {
  openDialog: (remainingSeconds: number, logOutUrl: string) => void;
  closeDialog: () => void;
};

export const globalDialogInit = () => {
  const inactivityDialogConfig: InactivityDialogConfig = {
    openDialog: (remainingSeconds: number, logOutUrl: string) => {},
    closeDialog: () => {}
  };

  window.p2lInactivityDialogConfig = inactivityDialogConfig;
};

declare global {
  interface Window {
    p2lInactivityDialogConfig: InactivityDialogConfig;
  }
}
